export const PREFIX = 'KENMEI_LIST'
export const CONST = (value) => (PREFIX + '_' + value)
export const SYSTEM_INIT = CONST('SYSTEM_INIT')
export const REDUCER_INIT = CONST('REDUCER_INIT')

export const systemInit = () => ({
  type: SYSTEM_INIT,
  payload: {
  }
})

export const reducerInit = (branchOffices, departments, customers) => ({
  type: REDUCER_INIT,
  payload: {
    branchOffices: branchOffices,
    departments: departments,
    customers: customers,
  }
})



// WEBPACK FOOTER //
// ./src/actions/kenmeiList.js